<template>
    <div class="row">
        <snappy-table
            :endpoint="'vessels/' + vesselId + '/templates'"
            :columns="['name', 'campaigns_count', 'actions']"
            :template-methods="columnTemplates(timezone)"
            :templated-slot-names="['actions']"
            :headings="['Name', 'Times Used', 'Actions']"
            :default-ordering="{column: 'created_at'}"
            record-type="Campaign Templates"
        >
            <template #actions="{ row }">
                <div>
                    <button :disabled="handlingCreate" @click="handleCreate(row)" class="button btn-primary d-flex align-items-center">
                      <template v-if="creating === row.id">
                        <i class="fa fa-solid fa-spinner fa-spin mr-3"></i>
                        <span class="text-nowrap">Creating Campaign</span>
                      </template>
                      <template v-else>
                        <i class="fa fa-solid fa-plus mr-3"></i>
                        <span>Personalize</span>
                      </template>
                    </button>
                </div>
            </template>
        </snappy-table>
    </div>
</template>

<script>
import SnappyTable from '../../components/SnappyTable';
import columnTemplates from '../../mixins/tables/columnTemplates';
import {listenToPusherNotifications} from "../../utility/notifications/listenToPusherNotifications";
import {createCampaign} from "../../utility/api/campaign/createCampaign";

export default {
    name: 'campaign-templates-table',
    components: {SnappyTable},
    mixins: [columnTemplates],
    methods: {
        handleCreate(row) {
            this.handlingCreate = true;
            this.creating = row.id;
            listenToPusherNotifications((notification) => {
                if (notification.type === 'campaign-creation-finished' && notification.template_id === row.id) {
                    setTimeout(() => window.location.href = notification.message.cta.url, 1000)
                }
            })
            createCampaign({template_id: row.id})
                .then(() => {
                  $.notify('Campaign creation process has started, we will notify you once it completes.', 'success');
                })
                .catch(() => {
                  $.notify('Campaign Creation Failed - please try again', 'error');
                })
        }
    },
    data() {
        return {
            'handlingCreate': false,
            creating: false,
        };
    },
    props: {
        vesselId: {
            type: Number,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
    },
};
</script>
